import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars


export const CodeBlock = ({language, code}) => {
    let html = '';
    if (language === 'curl') {
        language = '';
    }
    if (!code) {
        code = '';
    }
    if (code && language && process.env.BROWSER) {
        /* eslint-disable @typescript-eslint/no-require-imports */
        const Prism = require('prismjs');
        require('prismjs/components/prism-clike');
        require('prismjs/components/prism-javascript');
        require('prismjs/components/prism-c');
        require('prismjs/components/prism-java');
        require('prismjs/components/prism-objectivec');
        require('prismjs/components/prism-python');
        require('prismjs/components/prism-swift');
        /* eslint-enable @typescript-eslint/no-require-imports */
        html = Prism.highlight(code, Prism.languages[language], language);
    } else {
        html = `<span>${code}</span>`;
    }

    return (
        <pre className={`language-${language}`}>
            <code dangerouslySetInnerHTML={{__html: html}}></code>
        </pre>
    );
};
